import { atom } from "jotai";
import { getCurrentYear } from "../../helper/time";

export const currentYearForPremiumAndBasicAtom = atom(getCurrentYear());